import { enqueueSnackbar } from 'actions';
import { DownloadFile } from 'actions/sessionActions.js';

import {
	GetTacticalAssignmentRequest,
	GetStrategicAssignmentRequest
} from '../requests/TransportIpAssignmentRequests.js';

export const GET_TACTICAL_ASSIGNMENT_REQUEST = 'GET_TACTICAL_ASSIGNMENT_REQUEST';
export const GET_STRATEGIC_ASSIGNMENT_REQUEST = 'GET_STRATEGIC_ASSIGNMENT_REQUEST';

export const GetTacticalAssignment = (hubList, userName, userId) => async (dispatch) => {
	await GetTacticalAssignmentRequest(hubList, userName, userId).then(response => {
		dispatch(DownloadFile(response.data));
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};

export const GetStrategicAssignment = (hubList, userName, userId) => async (dispatch) => {
	await GetStrategicAssignmentRequest(hubList, userName, userId).then(response => {
		dispatch(DownloadFile(response.data));
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};
